import BasicModal from '@/components/UI/Dialog'
import { useTranslation } from 'react-i18next'
import KnowledgeDatatableComponentGridView from '../../../components/UI/KnowledgeDatatableComponent/KnowledgeDatatableComponentGridView'

export default function CreateQuestionFromDocument(props: any) {
  const { t } = useTranslation('translation')
  return (
    <BasicModal
      {...props}
      sx={{ width: 960, height: '90vh', overflowY: 'auto', p: 2 }}
      title={t('Generate from Uploaded Document')}
      subTitle={t(
        'Select the knowledge or document you would like to create questions from',
      )}
      showCloseButton
      slotProps={{
        title: { sx: { fontSize: '16px' } },
        subTitle: { sx: { fontSize: '14px' } },
      }}
    >
      <KnowledgeDatatableComponentGridView
        createFromUploadedDocument
        selectedGroupIdForDocument={props.selectedGroupIdForDocument}
        isEditQuiz={props.isEditQuiz}
        quizId={props.quizId}
        queTypes={props.queTypes}
        questionBank={props.questionBank}
        document_Id={props.document_Id}
        addMoreQuestionFromDocument
      />
    </BasicModal>
  )
}
